const FEEDBACK_TIMEOUT = 2000;

function showFeedback($share) {
    const label = $share.dataset.shareCopied;

    if (!label || $share.dataset.shareBusy) {
        return;
    }

    const original = $share.textContent;

    $share.dataset.shareBusy = '1';
    $share.textContent = label;

    setTimeout(() => {
        $share.textContent = original;
        delete $share.dataset.shareBusy;
    }, FEEDBACK_TIMEOUT);
}

function legacyCopy(url) {
    const $input = document.createElement('textarea');

    $input.value = url;
    $input.setAttribute('readonly', 'readonly');
    $input.style.position = 'absolute';
    $input.style.left = '-9999px';

    document.body.appendChild($input);
    $input.select();

    let copied = false;

    try {
        copied = document.execCommand('copy');
    } catch (err) {
        copied = false;
    }

    document.body.removeChild($input);

    return copied;
}

async function copyToClipboard(url) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
        try {
            await navigator.clipboard.writeText(url);
            return true;
        } catch (err) {
            // valt terug op legacyCopy
        }
    }

    return legacyCopy(url);
}

document.addEventListener('click', async (e) => {
    const $share = e.target.closest('.js-share');

    if (!$share) {
        return;
    }

    e.preventDefault();

    const url = $share.dataset.shareUrl || window.location.href;
    const title = $share.dataset.shareTitle || document.title;
    const text = $share.dataset.shareText || '';

    if (navigator.share) {
        try {
            await navigator.share({ title, text, url });
            return;
        } catch (err) {
            // Deelvenster geannuleerd: niet doorgaan naar het kopieren
            if (err.name === 'AbortError') {
                return;
            }
        }
    }

    if (await copyToClipboard(url)) {
        showFeedback($share);
    }
});
